import React from 'react';

import ActionBar from '../../components/ActionBar';

import AreasTable from './AreasTable';

import classes from './DataPanel.module.css';

const AreasPanelInsert = ({
    handleSearch,
    handleSort,
    areas,
    order,
    orderBy,
    type
}) => {
    return (
        <React.Fragment>
            <ActionBar
                onSearch={(searchTerm) => {handleSearch(searchTerm, type);}}
            />
            <div className={classes.scrollContainer}>
                <AreasTable
                    areas={areas}
                    order={order}
                    orderBy={orderBy}
                    onSort={handleSort}
                />
            </div>
        </React.Fragment>
    );
};

export default AreasPanelInsert;
